<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>{{$t("CopyrightLeft")}} @ {{ new Date().getFullYear() }}</span>
        <span class="md:flex hidden items-center">
            <span>{{$t("CopyrightRight")}}</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
